export const fbConfig = {
	apiKey: "AIzaSyDJhTqhsKNeWA2SK4uos4JUtxyoJ_jnA70",
	authDomain: "amber-bellante.firebaseapp.com",
	projectId: "amber-bellante",
	storageBucket: "amber-bellante.firebasestorage.app",
	messagingSenderId: "989857343428",
	appId: "1:989857343428:web:5131f36568fa50d4572691",
	measurementId: "G-72ZYQ0SQ84"
};
